import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Button, Link, Stack, TextField, Typography } from '@mui/material';
import { _ } from '/@/locale';

const FormCard = ({
    value,
    error,
    onChange,
    onSubmit,
    onOpenLoteModal,
    children,
}: {
    value: string;
    error: boolean;
    onChange: (value: string) => void;
    onSubmit: (event?: React.FormEvent) => void;
    onOpenLoteModal: () => void;
    children?: React.ReactNode;
}) => {
    return (
        <Box
            sx={{
                backgroundColor: '#F5F5F5',
                border: (t) => `1px solid ${t.palette.divider}`,
                px: 2,
                py: 3,
            }}
        >
            <Stack
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent='space-between'
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                spacing={1}
                mb={3}
            >
                <Typography variant='h6' color='primary'>
                    {_('Ingresá el número de lote de la bolsa de maíz')}
                </Typography>
                <Link
                    component='button'
                    type='button'
                    underline='always'
                    onClick={onOpenLoteModal}
                    color='secondary'
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <HelpOutlineIcon sx={{ fontSize: 14, mr: 0.5 }} />
                    {_('Dónde encontrar el número de lote')}
                </Link>
            </Stack>
            <form onSubmit={onSubmit}>
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    alignItems='center'
                    alignContent='flex-start'
                >
                    <TextField
                        fullWidth
                        value={value}
                        placeholder='XX0000000'
                        onChange={(e) => onChange(e.target.value)}
                        error={error}
                        helperText={error ? _('No obtuvimos resultados para el lote ingresado.') : undefined}
                        inputProps={{ maxLength: 20 }}
                        sx={{
                            background: 'white',
                            '& .MuiOutlinedInput-notchedOutline': {
                                top: '-10px',
                            },
                        }}
                        size='small'
                    />
                    <Button
                        type='submit'
                        variant='contained'
                        disabled={!value}
                        color='secondary'
                        sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                    >
                        {_('Ver información')}
                    </Button>
                </Stack>
                {children}
            </form>
        </Box>
    );
};

export default FormCard;
